import {DateTime} from 'luxon';
import {useQuery} from 'react-query';
import {buildEndpoint} from '../endpoints';
import {apifetch} from '../robotapi';

const getModelPortfoliosReturnRatesUrl = (id: string) => buildEndpoint(['modelportfolio', id, 'monthlyreturnrates']);

export const getModelPortfoliosReturnRatesApiCall = (id: string) =>
    apifetch<MonthlyReturnRatesResponse>(getModelPortfoliosReturnRatesUrl(id), 'GET');

export const useGetModelPortfoliosMonthlyReturns = (
    id: string | undefined,
    startDate: DateTime = DateTime.now().minus({ years: 100 }),
    endDate: DateTime = DateTime.now(),
) => {
    const startDateFormatted = startDate.toFormat('yyyy-MM-dd');
    const endDateFormatted = endDate.toFormat('yyyy-MM-dd');

    return useQuery<MonthlyReturnRatesResponse>(
        ['portfolios', id, 'returnrates', startDateFormatted, endDateFormatted],
        async () => {
            return await getModelPortfoliosReturnRatesApiCall(id!)();
        },
        {enabled: !!id},
    );
};

export interface MonthlyReturnRate {
    date: string;
    return: number;
}

export interface MonthlyReturnRatesResponse {
    modelPortfolioId: string;
    monthlyReturnRates: MonthlyReturnRate[];
}
